export default {
    createCompanyHoliday: 'สร้างวันหยุดบริษัท',
    updateCompanyHoliday: 'แก้ไขวันหยุดบริษัท',
    name: 'ชื่อ',
    date: 'วันที่',
    oneDay: 'วันหยุดหนึ่งวัน',
    multipleDay: 'วันหยุดหลายวัน',
    description: 'คำอธิบาย',
    thisFieldIsRequired: 'กรุณากรอกข้อมูล',
    thisFieldIsExceededCharacters: 'ข้อความเกิน 255 ตัวอักษร',
    save: 'บันทึก',
    congratulation: 'ยินดีด้วย',
    companyHolidayIsUpdated: 'วันหยุดบริษัทถูกอัปเดตแล้ว',
    companyHolidayIsCreated: 'วันหยุดบริษัทถูกสร้างแล้ว',
    errorMessages: 'เกิดข้อผิดพลาด',
    errorDateFormat: 'รูปแบบวันหยุดไม่ถูกต้อง',
    errorDateDuplicate: 'มีวันที่นี้ถูกใช้งานเเล้ว'
}
